module.exports = __webpack_public_path__ + "img/报名提示_背板@2x.64950a7a.png";